/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import PropTypes from 'prop-types';
import { Component } from 'react';
import { withRouter } from 'react-router';

import { LocationType } from 'Type/Common';
import media, { PRODUCT_MEDIA } from 'Util/Media/Media';

import ProductGallery from './ProductGalleryBaseImage.component';
import { INITIAL_SCALE, TRANSFORMATION_DELAY, TRANSFORMATION_SPEED } from './ProductGalleryBaseImage.config';
import { ProductGalleryBaseImageContainer as SourceProductGalleryBaseImageContainer  } from 'SourceComponent/ProductGalleryBaseImage/ProductGalleryBaseImage.container';

/** @namespace Component/ProductGalleryBaseImage/Container */
export class ProductGalleryBaseImageContainer extends SourceProductGalleryBaseImageContainer {
    _getSrc() {
        const {
            mediaData: { file, base: { url: baseUrl } = {} },
            isZoomEnabled
        } = this.props;

        if (!isZoomEnabled) {
            return baseUrl || media(file, PRODUCT_MEDIA);
        }

        const customUrl = file ? file : baseUrl;

        return customUrl;
    }
}

export default withRouter(
    ProductGalleryBaseImageContainer
);
